import axiosInstance from "../utils/axiosInstance";

const getStatus = url => axiosInstance.get(url).then(res => res);

export default getStatus;
